var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dx-scroll-view',{staticClass:"dx-card single-card",attrs:{"height":"auto"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }